import router from '../../router/index'
import axios from 'axios'
import config from './config'
axios.defaults.timeout = 10000
axios.defaults.withCredentials = true
axios.defaults.crossDomain = true
// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    return config
  },
  error => {
    return Promise.reject(err)
  }
)
let vm = this
// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          // err.message = '请求错误'
          router.replace({path: '/404', query: {}})
          break

        case 401:
          // err.message = 'message.401'
          router.replace({path: '/404', query: {}})
          break

        case 403:
          // err.message = 'message.403'
          // 返回 401 清除token信息并跳转到登录页面
          // store.commit(types.LOGOUT);
          router.replace({path: '/', query: {}})
          break

        case 404:
          err.message = 'message.404'
          console.log(err.response.config.url)
          // router.replace({path: '/404', query: {}})
          break

        case 408:
          // err.message = '请求超时'
          router.replace({path: '/404', query: {}})
          break

        case 500:
          // 维护
          // err.message = 'message.500'
          router.replace({path: '/500', query: {}})
          break

        case 501:
          // err.message = '服务未实现'
          router.replace({path: '/500', query: {}})
          break

        case 502:
          // err.message = '网关错误'
          router.replace({path: '/500', query: {}})
          break

        case 503:
          // err.message = '服务不可用'
          router.replace({path: '/500', query: {}})
          break

        case 504:
          // err.message = '网关超时'
          router.replace({path: '/500', query: {}})
          break

        case 505:
          // err.message = 'HTTP版本不受支持'
          router.replace({path: '/500', query: {}})
          break

        default:
      }
    } else {
      // err.message = '网络出现问题，请稍后再试'
    }
    // Message({
    //   type: 'error',
    //   center: true,
    //   message: err.message
    // })
    return Promise.reject(err)
  }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get (url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(config.webUrl + url, {
      params: params
    })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(config.webUrl + url, data)
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/common/js/http.js